module.exports = [{
      plugin: require('../plugins/gatsby-plugin-matomo-cust/gatsby-browser.js'),
      options: {"plugins":[],"matomoUrl":"https://stats.excom.fgov.be","dev":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
